import { ParamsConfDto } from '@/types/ParametersConfiguration';
import { SET_PARAM_CONFIGURATION, SET_PARAMS_CONFIG } from '../types';

const initialState = {
  parameters: [],
  modified: false,
};

export default (state: ParamsConfDto = initialState, action: { type: string; payload: any }) => {
  let newState = {};

  switch (action.type) {
    case (SET_PARAMS_CONFIG):
      newState = action.payload;
      break;

    case (SET_PARAM_CONFIGURATION): {
      const { key, value } = action.payload;
      const newParameters = state?.parameters?.length > 0 ? state?.parameters : [{ id: key, value }];
      newState = {
        ...state,
        parameters: (newParameters).map((param) => (param?.id === key) ? { ...param, value } : param),
      };
    }
      break;

    default:
      break;
  }

  return {
    ...state,
    ...newState,
  };
};

export const getParamsConfig = (state) => state.paramsConfigReducer;
export const getParamConfiguration = (state, key: string) => {
  const params = state.paramsConfigReducer?.parameters ?? [];

  return params.find((param) => param?.id === key)?.value || null;
};
